import { StyledQRButton, StyledIconButton } from './QRButton.styles';

interface QRButtonProps {
  onClick: () => void;
  className?: string;
}

function QRButton({ onClick, className }: QRButtonProps) {
  return (
    <StyledIconButton aria-label="QR Button" className={className} disableRipple onClick={onClick}>
      <StyledQRButton fontSize="large" />
    </StyledIconButton>
  );
}

export default QRButton;
